var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"cross",attrs:{"src":_vm.brandAsset(_vm.closeIcon, _vm.closeIconSanne),"alt":"Leave"},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }